import { motion } from "framer-motion";
import React, { useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { GeneralApi } from "../../Api/General";
import { QuizAPI } from "../../Api/Quiz";
import { Description, Header, Headline, Title } from "../../Components/CustomComponent";
import NotiFicationContainerBox from "./component/NotiFicationContainerBox";
import WinnerBar from "./component/WinnerBar";
import styles from "./index.module.scss";

const LeaderBoard = () => {
  const quizAPI = QuizAPI();
  const [active, setActive] = useState("weekly");
  const [isExpanded, setIsExpanded] = useState(false);
  const winnerapi = GeneralApi();
  const location = useLocation();
  const navigate = useNavigate();

  const quiz_id = useMemo(
    () => location.state?.quiz_id,
    [location.state?.quiz_id]
  );

  const {
    data: winners = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["leader-board", quiz_id, active],
    queryFn: async () => {
      const params = {
        quiz_id: quiz_id || '',
        type: active === "weekly" ? "weekly" : "",
      };
      const response = await winnerapi.getLeaderBoard(params);
      return response.data;
    },
  });

  const {
    data: info = {},
    isLoading: isInfoLoading,
  } = useQuery({
    queryKey: ["leader-board", "info", quiz_id],
    queryFn: async () => await quizAPI.getUserLeaderboardInfo(quiz_id),
  });

  const [first, seconds, third] = winners?.slice(0, 3);


  return (
    <div className={`${styles.LeaderBoard} container`}>
      <span
        onClick={() => navigate(-1)}
        className={`${styles.toggleButton}`}
      >
        <img src="/assets/cross.png" />
        {/* <GiHamburgerMenu /> */}
      </span>
      <div
        className={`${styles.Header} d-flex align-items-center justify-content-center`}
      >
        <Title text="Leader Board" classes={styles.Heading} />
      </div>
      <div
        className={`${styles.Filter} mt-5 w-100 d-flex align-items-center justify-content-center `}
      >
        <div
          className={`${styles.FilterTypes} d-flex align-items-center justify-content-between`}
        >
          <p
            className={active === "weekly" && styles.Active}
            onClick={() => setActive("weekly")}
          >
            Weekly
          </p>
          <p
            className={active === "alltime" && styles.Active}
            onClick={() => setActive("alltime")}
          >
            All Time
          </p>
        </div>
      </div>
      {(!isInfoLoading && !info.data.rank) ? <></> :
        <div
          className={`${styles.BoxText} mt-3 d-flex align-items-center justify-content-center`}
        >
          <div
            className={`${styles.InnerContent} d-flex align-items-center gap-4 text-center justify-content-center`}
          >
            {isInfoLoading ? "" : <div className={`${styles.YellowBox}`}>{`#${info.data.rank}`}</div>}
            {(isInfoLoading) ? <Spinner style={{ color: "white" }} /> :
              <Headline
                text={`You are doing better than ${info.data.performance || 0}% of other players!`}
                classes={`${styles.Text}`}
              />}
          </div>
        </div>
      }

      {isLoading ? "" :
        !winners?.length ? <div className="w-100 h-100 d-flex align-items-center justify-content-center">
          <Header
            text="No member score in this quiz"
            classes="text-center my-3"
          />
        </div> :
          <div
            className={`${styles.Graph} mt-5 mb-4 d-flex align-items-center justify-content-center`}
          >
            {[seconds, first, third]?.map((winner, index) => {
              if (!winner) return null;
              else
                return (
                  <motion.div
                    key={index}
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: index * 0.2 }}
                    className={styles.Graph}
                  >
                    <div
                      className={`d-flex flex-column align-items-center justify-content-center ${styles.Details}`}
                    >
                      <img
                        src={winner.image_url}
                        alt="winner"
                        className="image-fluid object-fit-contain rounded-circle"
                        width="78px"
                        height="78px"
                      />
                      <Description text={winner.name} classes={styles.Name} />
                      <div className={`mt-2 ${styles.Score}`}>
                        <p>Score: {winner.total_coins}</p>
                      </div>
                    </div>
                    <WinnerBar
                      rank={`${index + 1}`}
                      text={index + 1}
                      className="mt-5"
                    />
                  </motion.div>
                );
            })}
          </div>
      }

      <div
        className={`${styles.NotificationContainer} ${isExpanded ? styles.expanded : ""
          } w-100 mt-5`}
        onClick={() => setIsExpanded(!isExpanded)} // Toggle height on click
      >
        <div className="d-flex flex-column align-items-center justify-content-center">
          {winners?.slice(3, winners?.length).map((item, index) => (
            <NotiFicationContainerBox
              key={index}
              countNumber={index + 4}
              data={item}
            />
          ))}
        </div>
      </div>
    </div>

  );
};

export default LeaderBoard;
